module.exports = __webpack_public_path__ + "img/example.2de6ef57.png";